/* eslint-disable react-hooks/exhaustive-deps */
import { Col, Pagination, Row, Tooltip } from 'antd';
import _ from 'lodash';
import moment from 'moment';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { Axios } from 'axios';
import { default as classNames } from 'classnames';
import AIView from '../../assets/icons/ai-view.svg';
import { default as IconSize9On } from '../../assets/icons/Grid-3x2.svg';
import LayoutSingle from '../../assets/icons/layout-single.svg';
import ViewStreamComponent from '../../components/VideoStream';
import * as SERVICE from '../../constants/service.types';
import {
  VIEW_STREAM_SERVICE_EXTEND,
  ZOOM_STATE,
} from '../../constants/system.keys';
import useElementDimensions from '../../hooks/useElementDimensions';
import {
  clearAlert,
  resetGenerateLinkStorageFileByTime,
  setLoadingGenerateLinkStorageFileByTime,
  socketEmitEvent,
  toggleSmartMode,
} from '../../redux/actions';
import AlertBox from '../Live/AlertBox';
import '../Live/index.scss';
import CameraList from './CameraList';
import CameraSlider from './CameraSlider';
import CameraViewInfo from './CameraViewInfo';
import DeviceInfoCard from './DeviceInfoCard';
import FilterPlayback from './FilterPlayback';
import './index.scss';
import ProgressBar from './ProgressBar';

const sortByName = (a, b) => {
  if (a?.name < b?.name) {
    return -1;
  }

  if (a?.name > b?.name) {
    return 1;
  }

  return 0;
};

const REDUCE_DIMENSIONS = 5;

const PlaybackPage = () => {
  const { t } = useTranslation();
  const [requestId, setRequestId] = useState(new Date().getTime());
  const [selectedCamera, setSelectedCamera] = useState();
  const [selectedStream, setSelectedStream] = useState();
  const handleFullScreen = useFullScreenHandle();
  const [gateways, setGateways] = useState([]);
  const [ipAddress, setIpAddress] = useState('0.0.0.0');
  const [data, setData] = useState();
  const [selectedDate, setSelectedDate] = useState(moment());
  const [viewType, setViewType] = useState(2);
  const [played, setPlayed] = useState(0);
  const topRef = useRef();
  const playerRefs = useRef({});
  const [seekTime, setSeekTime] = useState(0);
  const [layoutMode, setLayoutMode] = useState('single');
  const [progressTime, setProgressTime] = useState({});
  const [isFullscreen, setFullScreen] = useState(false);
  const [selectedCameraGroup, setSelectedCameraGroup] = useState({
    value: 0,
    label: t('All group'),
  });

  const [pagination, setPagination] = useState({
    page: 1,
    size: layoutMode === 'grid' ? 6 : 5,
    quality: ZOOM_STATE.THREE,
    grid: [1, 1],
  });
  const { dimensions, ref } = useElementDimensions(data);

  const {
    camerasPlayback,
    deviceGroupPlayback,
    gatewayStates,
    namespace,
    generateLinkStorageFileByTime,
    infoStorageCamera,
    enabledSmartMode,
    detectionAlerts,
    streams,
  } = useSelector((state) => state);

  const totalPage = deviceGroupPlayback
    ? Math.ceil(
        deviceGroupPlayback?.totalDevicesGroup / (layoutMode === 'grid' ? 6 : 5)
      )
    : Math.ceil(camerasPlayback?.total / (layoutMode === 'grid' ? 6 : 5));

  const dispatch = useDispatch();

  const cameraDimensions = useMemo(() => {
    const { grid } = pagination;
    const { width: containerWidth, height: containerHeight } = dimensions || {};
    return {
      width: containerWidth / grid?.[0] - REDUCE_DIMENSIONS,
      height: containerHeight / grid?.[1] - REDUCE_DIMENSIONS,
    };
  }, [dimensions, pagination.grid]);

  const getDeviceContactInfo = useCallback(() => {
    if (selectedStream?.serial && namespace && viewType === 2) {
      let dataBody = {
        namespace,
        serial: selectedStream?.serial,
      };
      let dataObj = {
        appServiceType: SERVICE.GET_DEVICE_CONTACT_INFO,
        requestId: new Date().getTime(),
        body: JSON.stringify(dataBody),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [selectedStream?.serial, namespace, dispatch]);

  useEffect(() => {
    return () => {
      setIpAddress(null);
      setGateways(null);
      setData(null);
    };
  }, []);

  const generateNumericId = () => {
    const timestamp = Date.now();
    const randomNum = Math.floor(Math.random() * 1000);
    return timestamp + randomNum;
  };

  const handleGetRecordOfCamera = useCallback(
    (serial) => {
      const requestId = generateNumericId();
      const fromTime = selectedDate.format('YYYY-MM-DD');
      let dataBody = {
        serial: serial,
        fromTime: fromTime,
        toTime: moment(fromTime).add(1, 'day').format('YYYY-MM-DD'),
        namespace,
      };

      let dataObj = {
        appServiceType: SERVICE.LIST_PLAYBACK_ON_CLOUD,
        requestId: requestId,
        body: JSON.stringify(dataBody),
      };

      dispatch(socketEmitEvent(dataObj));

      return requestId;
    },
    [selectedDate]
  );

  const fetchData = () => {
    if (viewType === 1) {
      return;
    }

    if (selectedCameraGroup.value === 0) {
      const camerasPlaybackData = camerasPlayback?.data.sort(sortByName) || [];

      const updatedData = camerasPlaybackData.map((item) => {
        const requestId = handleGetRecordOfCamera(item?.serial);
        return {
          ...item,
          key: requestId,
        };
      });
      setData(updatedData);
    } else {
      const deviceGroupPlaybackData =
        deviceGroupPlayback?.deviceGroup?.devices?.sort(sortByName);
      const updatedData = deviceGroupPlaybackData?.map((item) => {
        const requestId = handleGetRecordOfCamera(item?.serial);

        return {
          ...item,
          key: requestId,
        };
      });
      setData(updatedData);
    }
  };

  useEffect(() => {
    setData((pre) =>
      pre?.map((item) => {
        return {
          ...item,
          records: infoStorageCamera?.[item?.key]?.storageTimes || [],
        };
      })
    );
  }, [infoStorageCamera]);

  useEffect(() => {
    if (
      camerasPlayback?.data.length > 0 ||
      deviceGroupPlayback?.deviceGroup?.devices?.length > 0
    ) {
      fetchData();
    }
  }, [camerasPlayback, deviceGroupPlayback]);

  const convertTimeToSeconds = (timeString) => {
    const [hours, minutes, seconds] = timeString.split(':').map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  };

  const getAppearanceTimeStyle = useCallback(
    (records) => {
      if (!Array.isArray(records)) {
        return [];
      }
      const appearanceBlocks = [];
      let currentSecond = 0;

      const TOTAL_SECONDS_IN_DAY = 24 * 60 * 60;

      const seekTimeToSecond =
        seekTime !== 0 ? convertTimeToSeconds(seekTime) : null;

      if (seekTimeToSecond !== null) {
        const position = (seekTimeToSecond * 100) / TOTAL_SECONDS_IN_DAY + '%';
        appearanceBlocks.push({
          color: '#ffd900',
          width: '2px',
          position,
          zIndex: 999,
          isSeekTime: true,
        });
      }

      records.forEach((record) => {
        const { from, to } = record;

        if (from > currentSecond) {
          appearanceBlocks.push({
            color: '#e0e0e0',
            width: ((from - currentSecond) * 100) / TOTAL_SECONDS_IN_DAY + '%',
          });
        }

        const durationInSeconds = to - from;
        appearanceBlocks.push({
          color: '#1976d2',
          width: (durationInSeconds * 100) / TOTAL_SECONDS_IN_DAY + '%',
        });

        currentSecond = to;
      });

      if (currentSecond < TOTAL_SECONDS_IN_DAY) {
        appearanceBlocks.push({
          color: '#e0e0e0',
          width:
            ((TOTAL_SECONDS_IN_DAY - currentSecond) * 100) /
              TOTAL_SECONDS_IN_DAY +
            '%',
        });
      }

      return appearanceBlocks;
    },
    [seekTime]
  );

  const onChangeCamera = (values, data, name) => {
    setPagination({
      page: 1,
      size: layoutMode === 'grid' ? 6 : 5,
      quality: ZOOM_STATE.THREE,
    });
  };

  const onChangeSelect = (option) => {
    if (option.value === 0) {
      onChangeCamera(0, data);
      setSelectedCamera([]);
      setSelectedCameraGroup({
        value: 0,
        label: t('All group'),
      });
    } else {
      setSelectedCamera([]);
      setSelectedCameraGroup(option);
      getCamerasByGroup(option.value, 0, layoutMode === 'grid' ? 6 : 5);
    }
  };

  useEffect(() => {
    async function getInternalGateway(link, serial) {
      try {
        let result = await Axios.get(link);
        return result.status === 200 && result.data.serial === serial;
      } catch (error) {
        return false;
      }
    }
    if (gatewayStates && gatewayStates.requestId === requestId && ipAddress) {
      setGateways(
        gatewayStates.data.filter((gateway) => {
          if (
            ipAddress &&
            gateway.state === 1 &&
            gateway.ipAddress &&
            gateway.ipAddress === ipAddress &&
            gateway.localAddress &&
            gateway.localAddress.length > 0
          ) {
            return getInternalGateway(
              `http://${gateway.localAddress}:${gateway.portScan}/info`,
              gateway.serial
            );
          }
          return false;
        })
      );
    }
  }, [gatewayStates, ipAddress, requestId]);

  const onChangeSelectCamera = (option) => {
    setSelectedCamera(option);
    setSelectedStream(option[0]);
    if (option?.length !== 0) {
      setData(option);
      getSituationVideoRequest(option, caculatorTimeStamp(selectedDate));
    } else {
      setData(deviceGroupPlayback?.deviceGroup?.devices);
      getSituationVideoRequest(
        deviceGroupPlayback?.deviceGroup?.devices,
        caculatorTimeStamp(selectedDate)
      );
    }
  };

  const getDeviceByPage = useCallback(
    (page, size, dataSearch) => {
      let data = {
        namespace,
        deviceType: 'camera',
        timeRequest: requestId,
        page,
        size,
      };
      if (dataSearch) {
        data.name = dataSearch;
      }
      let dataObj = {
        appServiceType: SERVICE.LIST_ALL_DEVICE_BY_PAGE,
        requestId: 666,
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    },
    [dispatch, namespace, requestId]
  );

  const getCamerasByGroup = (selectGroupId, page, pageSize) => {
    const dataTimeRequest = new Date().getTime();
    setRequestId(dataTimeRequest);
    dispatch(
      socketEmitEvent({
        appServiceType: SERVICE.GET_DEVICE_GROUP_BY_ID,
        requestId: 777,
        body: JSON.stringify({
          page: page,
          size: pageSize,
          namespace,
          name: selectedCamera?.label,
          deviceGroupId: selectGroupId,
          timeRequest: dataTimeRequest,
        }),
      })
    );
  };

  useEffect(() => {
    if (selectedCameraGroup.value !== 0) {
      getCamerasByGroup(
        selectedCameraGroup.value,
        pagination.page - 1,
        pagination.size
      );
    } else {
      if (layoutMode === 'grid') {
        getDeviceByPage(pagination.page - 1, 6);
      } else {
        getDeviceByPage(pagination.page - 1, 5);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination]);

  const onChangeViewType = (e) => {
    setViewType(e.target.value);
  };

  const caculatorTimeStamp = (date) => {
    const selectedDateString = date?.format('YYYY-MM-DD');
    const dateTimeString = `${selectedDateString} ${
      seekTime !== 0 ? seekTime : '00:00:00'
    }`;
    const timestamp = moment(dateTimeString, 'YYYY-MM-DD HH:mm:ss').valueOf();
    return timestamp;
  };

  const handleSeek = (event) => {
    const seekBar = event.currentTarget;
    const seekBarRect = seekBar.getBoundingClientRect();
    const clickX = event.clientX - seekBarRect.left;
    const seekBarWidth = seekBarRect.width;
    const percentage = clickX / seekBarWidth;
    const totalSeconds = Math.floor(percentage * 86400);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const formattedSeekTime = `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    const timestamp = caculatorTimeStamp(selectedDate);

    setPlayed(percentage);

    if (!isNaN(timestamp)) {
      if (seekTime === 0) {
        //Fix set loading first time for CameraViewInfo
        const serials = (data || []).map((item) => item.serial);
        dispatch(setLoadingGenerateLinkStorageFileByTime(serials));
      }

      setSeekTime(formattedSeekTime);
    } else {
      console.error('Invalid timestamp');
    }
  };

  const handleSeekBack = () => {
    console.log('call api');
  };

  const handleSeekForward = () => {
    console.log('call api');
  };

  const getSituationVideoRequest = (data, timestamp) => {
    const serials = (data || []).map((item) => item.serial);
    dispatch(setLoadingGenerateLinkStorageFileByTime(serials));
    dispatch(resetGenerateLinkStorageFileByTime(serials));

    data?.length > 0 &&
      data.forEach((item) => {
        const dataTimeRequest = new Date().getTime();
        let data = {
          ipAddress: '0.0.0.0',
          deviceSerial: item?.serial,
          queryTime: moment(timestamp).format('YYYY-MM-DD HH:mm:ss'),
          namespace,
        };
        let dataObj = {
          appServiceType: SERVICE.GENERATE_LINK_STORAGE_FILE_BY_TIME,
          requestId: dataTimeRequest,
          body: JSON.stringify(data),
        };
        dispatch(socketEmitEvent(dataObj));
      });
  };

  const modeButtonsComponent = (pageSize) => (
    <div className="mode-button" style={{ display: 'flex', gap: 10 }}>
      <Tooltip placement="bottom" title={t('Toggle to slide view mode')}>
        <div
          onClick={() => {
            setLayoutMode('single');
            setSelectedStream(data[0]);
          }}
          className="mode"
        >
          <img width={20} height={20} src={LayoutSingle} alt="mode" />
        </div>
      </Tooltip>
      <Tooltip placement="bottom" title={t('Toggle to 3x2 view mode')}>
        <div
          onClick={() => {
            setLayoutMode('grid');
          }}
          className="mode"
        >
          <img
            className="icon"
            width={20}
            height={20}
            src={IconSize9On}
            alt="mode"
          />
        </div>
      </Tooltip>
    </div>
  );

  const onChangeDate = (date) => {
    if (seekTime !== 0 && data) {
      const timestamp = caculatorTimeStamp(date);
      getSituationVideoRequest(data, timestamp);
    } else {
      fetchData();
    }
  };

  const handleProgress = (serial, playedSeconds) => {
    setProgressTime((prev) => ({ ...prev, [serial]: playedSeconds }));
  };

  useEffect(() => {
    const handleReady = (serial) => {
      const startSecond =
        generateLinkStorageFileByTime?.[serial]?.startSecond ?? 0;
      const playerRef = playerRefs.current[serial];

      if (playerRef) {
        playerRef.seekTo(startSecond, 'seconds');
      }

      if (serial === selectedStream?.serial && topRef.current) {
        topRef.current.seekTo(startSecond, 'seconds');
      }
    };

    Object.keys(generateLinkStorageFileByTime || {}).forEach((serial) => {
      handleReady(serial);
    });
  }, [generateLinkStorageFileByTime]);

  useEffect(() => {
    if (selectedStream && topRef.current) {
      topRef.current.seekTo(
        progressTime[selectedStream.serial] || 0,
        'seconds'
      );
    }

    if (layoutMode === 'single') {
      getDeviceContactInfo();
    }
  }, [selectedStream]);

  // Mỗi lần data thay đổi thì set lại camera đầu tiên là camera được view
  useEffect(() => {
    if (data) {
      setSelectedStream(data?.[0]);
    }
  }, [data]);

  // nếu layoutMode thay đổi thì set lại số lượng camera hiển thị trên 1 trang, gọi api lấy video của các camera
  useEffect(() => {
    if (layoutMode === 'grid') {
      setPagination((state) => ({ ...state, size: 6 }));
    }

    if (layoutMode === 'single') {
      setPagination((state) => ({ ...state, size: 5 }));
    }
  }, [seekTime, layoutMode]);

  // Mỗi lần deviceGroupPlayback (camera sau khi chọn group), camerasPlayback (camera sau khi chọn all group) thay đổi
  // thì gọi hàm getSituationVideoRequest để lấy video của các camera

  useEffect(() => {
    const timestamp = caculatorTimeStamp(selectedDate);
    if (
      deviceGroupPlayback?.deviceGroup?.devices?.length > 0 &&
      seekTime !== 0
    ) {
      getSituationVideoRequest(
        deviceGroupPlayback?.deviceGroup?.devices?.sort(sortByName),
        timestamp
      );
    } else {
      camerasPlayback?.data?.length > 0 &&
        seekTime !== 0 &&
        getSituationVideoRequest(
          camerasPlayback?.data?.sort(sortByName),
          timestamp
        );
    }
  }, [deviceGroupPlayback, camerasPlayback]);

  useEffect(() => {
    let interval;

    if (viewType === 1 && streams?.length > 0) {
      interval = setInterval(() => {
        streams.forEach((item) => {
          if (item.serial === selectedStream.serial) {
            const dataTimeRequest = new Date().getTime();
            const dataBody = {
              serial: item.serial,
              namespace,
            };
            let dataObj = {
              appServiceType: SERVICE.PING_PLAYBACK_CAMERA,
              requestId: dataTimeRequest,
              body: JSON.stringify(dataBody),
            };
            dispatch(socketEmitEvent(dataObj));
          }
        });
      }, 10 * 1000);
    }

    return () => clearInterval(interval);
  }, [viewType, streams]);

  const currentQueryTime = useMemo(
    () =>
      selectedDate
        ? moment(caculatorTimeStamp(selectedDate)).format('YYYY-MM-DD HH:mm:ss')
        : '',
    [selectedDate, seekTime]
  );

  const compare = (a, b) => {
    if (a.resolution > b.resolution) {
      return -1;
    }
    if (a.resolution < b.resolution) {
      return 1;
    }
    return 0;
  };

  const onCheckZoomState = (
    dataArr,
    zoomState,
    zoomStateDefault,
    resolutionDefault
  ) => {
    if (zoomState >= 0) {
      if (dataArr?.find((item) => item.zoomState === zoomState)) {
        return {
          dataZoomStates: [...dataArr],
          zoomState,
          resolution: dataArr?.find((item) => item.zoomState === zoomState)
            ?.resolution,
        };
      } else {
        return onCheckZoomState(
          dataArr,
          zoomState - 1,
          zoomStateDefault,
          resolutionDefault
        );
      }
    } else {
      return {
        dataZoomStates: [...dataArr],
        zoomState: zoomStateDefault,
        resolution: resolutionDefault,
      };
    }
  };

  const onZoomState = (camera) => {
    let dataZoomState =
      (camera?.subSources &&
        JSON.parse(camera?.subSources)?.map((item) => ({
          resolution: item.resolution,
          zoomState: item.zoomState,
        }))) ??
      [];
    if (
      !dataZoomState?.find((item) => item.resolution === camera?.resolution)
    ) {
      dataZoomState = [
        ...dataZoomState,
        {
          resolution: camera?.resolution,
          zoomState: camera?.zoomState,
        },
      ];
    }
    const dataArr = dataZoomState
      ?.filter((item) => item.resolution >= 0 && item.zoomState >= 0)
      ?.sort(compare);
    const zoomState = null;
    const dataTemp = onCheckZoomState(
      dataArr,
      zoomState,
      camera?.zoomState,
      camera?.resolution
    );
    const dataZoomStateMin = _.minBy(dataTemp?.dataZoomStates, 'resolution');
    const dataTemp1 = {
      ...dataTemp,
      resolution: dataZoomStateMin?.resolution ?? camera?.resolution,
      zoomState: dataZoomStateMin?.zoomState ?? camera?.zoomState,
    };
    return dataTemp1;
  };

  return (
    <div className="playback-component">
      <Row gutter={[16, 16]} style={{ height: '100%' }}>
        <Col span={6}>
          <FilterPlayback
            onChangeDate={onChangeDate}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            selectedCamera={selectedCamera}
            onChangeSelectCamera={onChangeSelectCamera}
            selectedCameraGroup={selectedCameraGroup}
            onChangeSelect={onChangeSelect}
            viewType={viewType}
            onChangeViewType={onChangeViewType}
          />
        </Col>
        <Col
          span={18}
          style={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            {modeButtonsComponent(pagination.size)}
            {layoutMode === 'grid' && (
              <div className="pagination">
                <Pagination
                  showSizeChanger={false}
                  current={pagination.page}
                  onChange={(value) => {
                    setPagination((state) => ({ ...state, page: value }));
                  }}
                  total={
                    selectedCameraGroup?.value === 0
                      ? camerasPlayback?.total
                      : deviceGroupPlayback?.totalDevicesGroup
                  }
                  pageSize={pagination.size}
                />
              </div>
            )}
          </div>

          {layoutMode === 'grid' && (
            <>
              <div style={{ paddingTop: 10, minHeight: '74vh' }}>
                {gateways && (
                  <CameraList
                    layout={'grid'}
                    data={data}
                    isSeeking={seekTime}
                    getAppearanceTimeStyle={getAppearanceTimeStyle}
                    playerRefs={playerRefs}
                    handleProgress={handleProgress}
                    handleFullScreen={handleFullScreen}
                    setLayoutMode={setLayoutMode}
                    setSelectedStream={setSelectedStream}
                  />
                )}
              </div>
            </>
          )}

          {layoutMode === 'single' && (
            <div style={{ paddingTop: 8 }}>
              <Row gutter={[24, 24]}>
                <Col span={14}>
                  {viewType === 1 ? (
                    <div className="camera-component">
                      <div className="main-camera-component">
                        <FullScreen
                          handle={handleFullScreen}
                          onChange={(isFullScreen) => {
                            setFullScreen(isFullScreen);
                            //handle reset layout => fix break layout after toggle fullscreen mode
                            setPagination((prevState) => ({
                              ...prevState,
                              grid: prevState.grid,
                            }));
                            if (!isFullScreen) {
                              dispatch(toggleSmartMode(false));
                              dispatch(clearAlert([]));
                            }
                          }}
                        >
                          <div
                            key={selectedStream?.serial}
                            ref={ref}
                            onDoubleClick={() => {
                              handleFullScreen.exit();
                              setFullScreen(false);
                              dispatch(toggleSmartMode(false));
                              dispatch(clearAlert([]));
                            }}
                            gutter={[4, 4]}
                            className={classNames('main-live-page', {
                              fullscreen: handleFullScreen.active,
                              noneFullScreen: !handleFullScreen.active,
                            })}
                            id="main-live-page"
                            style={{
                              padding: isFullscreen ? '8px' : '',
                              width: isFullscreen ? '100%' : `100%`,
                            }}
                          >
                            <div
                              data-serial={selectedStream?.serial}
                              style={{
                                height: cameraDimensions.height,
                                width: '100%',
                                padding: '4px',
                              }}
                              className={classNames({
                                'camera-container': true,
                                fullscreen: isFullscreen,
                              })}
                            >
                              <ViewStreamComponent
                                isViewAll
                                allScreen={handleFullScreen.active}
                                zoomState={onZoomState(selectedStream)}
                                name={selectedStream.name}
                                typeCamera={selectedStream.typeCamera}
                                resolution={selectedStream.resolution}
                                serviceId={VIEW_STREAM_SERVICE_EXTEND.normal}
                                state={selectedStream.state}
                                serial={selectedStream.serial}
                                thumbnail={selectedStream.thumbnail}
                                playbackData={{
                                  queryTime: currentQueryTime,
                                }}
                                permission={selectedStream.permission}
                                isAllowStreaming={
                                  selectedStream.isAllowStreaming
                                }
                              />
                            </div>
                          </div>
                          <>
                            {isFullscreen && enabledSmartMode && (
                              <AlertBox
                                events={detectionAlerts}
                                pagination={pagination}
                                // onSelect={onSelectAlert}
                                setPagination={setPagination}
                                gateways={gateways}
                                data={data}
                              />
                            )}

                            {isFullscreen && !enabledSmartMode && (
                              <div
                                style={{
                                  position: 'fixed',
                                  right: '-10px',
                                  bottom: '-15px',
                                  width: '50px',
                                  height: '50px',
                                  cursor: 'pointer',
                                }}
                              >
                                <div
                                  style={{
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                  onClick={() => {
                                    dispatch(toggleSmartMode(true));
                                  }}
                                >
                                  <img src={AIView} alt="ai-view" />
                                </div>
                              </div>
                            )}
                          </>
                        </FullScreen>
                      </div>
                    </div>
                  ) : (
                    <CameraViewInfo
                      key={selectedStream?.serial}
                      topRef={topRef}
                      seekTime={seekTime}
                      selectedStream={selectedStream}
                    />
                  )}
                </Col>

                <Col span={10}>
                  <DeviceInfoCard selectedStream={selectedStream} t={t} />
                </Col>
              </Row>

              <CameraSlider
                data={data}
                isSeeking={seekTime}
                getAppearanceTimeStyle={getAppearanceTimeStyle}
                playerRefs={playerRefs}
                handleProgress={handleProgress}
                setSelectedStream={setSelectedStream}
                selectedStream={selectedStream}
                totalPage={totalPage}
                pagination={pagination}
                setPagination={setPagination}
              />
            </div>
          )}

          <ProgressBar
            played={played}
            handleSeek={handleSeek}
            handleSeekBack={handleSeekBack}
            handleSeekForward={handleSeekForward}
          />
        </Col>
      </Row>
    </div>
  );
};

export default PlaybackPage;
